<template>
  <div class="text">
    <div>
      <h4 class="fw-bold">1. Delivery</h4>
      <p>Delivery country - Germany</p>
      <p>Means of delivery - Standard</p>
      <p>Delivery costs: 2,99 €</p>
      <p>Delivery time ca. 3-4 Working days</p>
      <p>Minimum order value 29,90 €</p>
    </div>
    <div>
      <h4 class="fw-bold mt-5">2. Payment methods</h4>
      <p class="fw-bold">Credit card</p>
      <p>
        Payment by credit card involves the order amount being reserved from
        your card at the time of the order and charged to your card on dispatch
        of the order. For payment to be processed you require your card number,
        expiry date and where applicable the imprinted name and security code.
        The security code is a specially used safety function of credit card
        companies, through whose enquiries/entries will warrant the physical
        agreement of the credit card used to order.
      </p>
      <p>
        You will find the 3-digit proof number on the back of your VISA,
        MasterCard /Euro-card credit card. With American Express The 4 digit
        security code can be found on the front printed on the right hand side
      </p>
      <p class="fw-bold">PayPal</p>
      <p class="fw-bold">Do you already have a PayPal account?</p>
      <p>
        You will be forwarded to a PayPal payment page during the payment
        process. After making a successful payment using PayPal, you will be led
        back to the dress-for-less order confirmation page. Please note: Always
        make sure that you have sufficient credit on your PayPal account so that
        your transaction can be carried out successfully.
      </p>
      <p class="fw-bold">You don't yet have a PayPal account?</p>
      <p>
        In order to make payments using PayPal we suggest that you open a free
        account with PayPal. You can do this either during the checkout
        procedure at dress-for-less order, or on the following website:
        www.paypal.com
      </p>
    </div>
    <div>
      <h4 class="fw-bold mt-5">3. Returns</h4>
      <p class="fw-bold">Terms of revocation</p>
      <p class="fw-bold">Power of revocation</p>
      <p>
        You have the right to withdraw from this agreement within fourteen days
        without stating a reason. The period of revocation is fourteen days from
        the date on which the goods were accepted by you or by a third person
        appointed by you, who is not the carrier. In order to exercise your
        right of revocation, you must notify us -
      </p>
      <ul>
        <li>M.E.D.U.Z.Z.A.</li>
        <li>Mönchhofallee 1</li>
        <li>D-65451 Lauterbach Germany</li>
        <li>Phone: +49 (0) 1806 3675377</li>
        <li>Fax: +49 (0) 1805 7467329</li>
        <li>E-Mail: service@meduzza.de</li>
      </ul>
      <p>
        - in an unequivocal statement (e.g. letter sent by post, telefax or
        e-mail) of your decision to withdraw from the agreement. You may use the
        attached sample revocation form, however, this is not mandatory. Sending
        notification of your intention to exercise your right of revocation
        prior to expiry of the period of revocation shall be sufficient to
        comply with the period of revocation. Consequences of revocation If you
        withdraw from this agreement, we shall refund all payments that we have
        received from you, including delivery costs (with the exception of
        additional costs that arise if you have selected a form of delivery
        other than the cheapest form of standard delivery offered by us) without
        undue delay and within fourteen days at the latest from the date on
        which we received the notice of revocation. For this refund we use the
        same method of payment that you used for the original transaction,
        unless expressly agreed otherwise with you; in no event will you be
        charged any fees for this refund.
      </p>
      <p>
        We may refuse the refund until the goods have been returned to us or
        until you have provided evidence that you have returned the goods,
        whichever is earlier. You must return or hand over the goods to us -
      </p>
      <p class="fw-bold">Returns address:</p>
      <ul>
        <li>M.E.D.U.Z.Z.A.</li>
        <li>Mönchhofallee 1</li>
        <li>D-65451 Lauterbach Germany</li>
        <li>Fax: +49 (0) 1805 7467329</li>
        <li>E-Mail: service@meduzza.de</li>
      </ul>
      <p>
        - without undue delay and, at all events, within fourteen days at the
        latest from the date on which you notified us of your withdrawal from
        the agreement. The deadline shall be deemed to have been complied with
        if the goods are dispatched prior to expiry of the deadline. The
        immediate costs of returning the goods are borne by us for following
        countries: Germany, Austria and the Netherlands. In all other countries
        the immediate costs of returning the goods are borne by the customer.
        You shall only be required to compensate any loss of value if said loss
        of value can be attributed to any unnecessary handling of the goods for
        the purpose of testing the condition, properties and functionality of
        said goods.
      </p>
      <p class="fw-bold">End of terms of revocation</p>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Service",
};
</script>

<style scoped>
.text {
  margin: 100px 250px 60px 25px;
  text-align: start;
}
@media (max-width: 576px) {
  .text {
    font-size: 12px;
    width: 80%;
    margin-top: 120px;
  }
}
</style>
